import { DateTime } from 'luxon';

export const parseDateString = (date: string): Date => {
    if (date.includes('.')) {
        return DateTime.fromFormat(date, 'dd.MM.yyyy').toJSDate();
    }

    return new Date(date);
};

export const parseDate = (date: string) => DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd.MM.yyyy');

export const prepareDate = (date: string) => DateTime.fromFormat(date, 'dd.MM.yyyy').toFormat('yyyy-MM-dd');

export const normalizeDate = (date: string | null | undefined): string => {
    if (!date) return '';

    let dt: DateTime;

    // пробуем ISO
    dt = DateTime.fromISO(date);
    if (dt.isValid) {
        return dt.toFormat('dd.MM.yyyy');
    }

    // пробуем dd.MM.yyyy
    dt = DateTime.fromFormat(date, 'dd.MM.yyyy');
    if (dt.isValid) {
        return dt.toFormat('dd.MM.yyyy');
    }

    // пробуем yyyy-MM-dd (часто приходит без времени)
    dt = DateTime.fromFormat(date, 'yyyy-MM-dd');
    if (dt.isValid) {
        return dt.toFormat('dd.MM.yyyy');
    }

    return ''; // если ничего не распарсилось
};
